<template>
    <div>
        <b-alert
            v-if="user && !user.has_email"
            type="info"
            :message="
                readOnlyRules
                    ? t('default::title.email_remainder_not_permitted')
                    : t('default::title.add_email_remainder')
            "
            :has-header-button="!readOnlyRules"
            :button-title="t('default::title.add_email_remainder.go_to_profile_link')"
            @emitAction="gotToProfile()"
        >
        </b-alert>
    </div>
</template>

<script>
export default {
    name: 'AddEmailRemainder',
    components: {},
    props: {},
    data() {
        return {};
    },
    computed: {
        user() {
            return this.$store.state.user.profile;
        },
        readOnlyRules() {
            return !(this.can('api.v1.dms-users.update') || this.can('api.v1.dms-users.store'));
        },
    },
    created() {},
    methods: {
        gotToProfile() {
            if (this.user.is_dms_user) {
                if (this.can('api.v1.dms-users.update')) {
                    return this.goTo('dms-users.get', { dms_user: this.user.id });
                }

                return this.goTo('dms-users.profile');
            }

            return this.goTo('users.get', { user: this.user.id });
        },
        goTo(route, param = null) {
            if (param) {
                this.$root.goTo(this.$root.route(route, param ? param : false));
            } else {
                this.$root.goTo(this.$root.route(route));
            }
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .v-alert {
    top: 10px;
    padding: 0 20px;
    .header {
        align-items: center;
        display: flex;
        .alert-btn {
            height: 30px;
            border-color: #fff;
            padding: 0 20px !important;
        }
    }
}
.b-alert {
    padding: 0 16px;
}
</style>
